/// <amd-module name="Artifacts/Maven/components/MavenPackagePeople" />
import { MavenPomPerson } from "Artifacts/Maven/Contracts/Maven";
import * as MavenRes from "Artifacts/Maven/Resources";
import { PackageAttribute } from "Artifacts/Package/components/package-details-common/PackageAttribute";
import { PackagePerson } from "Artifacts/Package/components/package-details-common/PackagePerson";
import * as PackageRes from "Artifacts/Package/Resources";
import { IPerson } from "Artifacts/Root/types/IPerson";
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IMavenPackagePeopleProps {
  pageContext: IVssPageContext;
  developers: MavenPomPerson[];
  contributors: MavenPomPerson[];
}

export class MavenPackagePeople extends React.PureComponent<IMavenPackagePeopleProps> {
  public render(): JSX.Element {
    if (!this.props.developers && !this.props.contributors) {
      return <div />;
    }

    return (
      <div className="maven-package-people">
        <PackageAttribute title={PackageRes.PackagePeople_Title}>
          {this.props.developers.length > 0 && (
            <div>
              <div className="package-group-spacer" />
              <div className="package-group-header" role="heading" aria-level={3}>
                {MavenRes.MavenPackagePeople_Developers}
              </div>
              {this.props.developers.map((developer: MavenPomPerson) => {
                return (
                  <PackagePerson
                    pageContext={this.props.pageContext}
                    key={developer.name}
                    person={this.ToIPerson(developer)}
                  />
                );
              })}
            </div>
          )}
          {this.props.contributors.length > 0 && (
            <div>
              <div className="package-group-spacer" />
              <div className="package-group-header" role="heading" aria-level={3}>
                {MavenRes.MavenPackagePeople_Contributors}
              </div>
              {this.props.contributors.map((contributor: MavenPomPerson) => {
                return (
                  <PackagePerson
                    pageContext={this.props.pageContext}
                    key={contributor.name}
                    person={this.ToIPerson(contributor)}
                  />
                );
              })}
            </div>
          )}
        </PackageAttribute>
      </div>
    );
  }

  private ToIPerson(person: MavenPomPerson): IPerson {
    return {
      email: person.email,
      name: person.name,
      url: person.url,
    } as IPerson;
  }
}
